import './Login.scss';
import React, { useState, useRef, useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import jwt_decode from "jwt-decode";
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';
import { initUserData, login } from '../../../redux/features/authSlice';
import { buttonStyle1 } from '../../../utils/commonStyle';
import { setLoading } from '../../../redux/features/appSlice';
import { colors } from '../../../utils/colors';
// import vitarakatextlogo from '../../../assets/images/vitarakatextlogo.svg';
import FormTextField from '../../../components/FormTextField';
import Logo from '../../../assets/images/ze-logo.svg';

/**
 * Validation Schema for register
 */
const validationSchema = yup.object({
  email: yup
    .string('Enter your Email')
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, '*Invalid Email Address')
    .required('')
    .trim(),
  password: yup
    .string('Enter your Password')
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,12}$/, 'Enter a password of minimum 8 characters with a combination of capital letters, small letters, symbols, and numbers.')
    .required('')
    .trim(),
});

export default function Login() {
  const theme = useTheme();

  const dispatch = useDispatch();

  const isMobile = useMediaQuery('(max-width:1000px)');

  const formRef = useRef();

  const navigate = useNavigate();
  const [visibility, setVisibility] = useState(false);

  const { state } = useLocation();

  const [data, setData] = useState({
    email: state?.email ? state?.email : '',
    password: '',
  });

  /**
   * @param {email, password} obj
   * Login user
   */

  const loginApi = async (obj) => {
    dispatch(setLoading(true));
    let payload = {
      ...obj,
      deviceId: 'abc123',
    };
    const response = await appapi.post('auth/login', payload);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        // showmessage(data.message)
        localStorage.setItem('accessToken', data.response.accessToken);
        localStorage.setItem('refreshToken', data.response.refreshToken);
        appapi.setHeader('Authorization', `Bearer ${data.response.accessToken}`);
        const decoded = jwt_decode(data.response.accessToken);
        dispatch(login(decoded.sub));
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      if (response.status === 400) {
        let error = response.data.errors[0].message.replace('body.emailId', 'Email Id');
        showmessage(error, 'error');
      }
    }
  };

  /**
   *
   * @returns redirect to forgotPassword Page
   */
  const onClickForgotPassword = (values, errors) => {
    if (!Boolean(errors.email)) {
      navigate(`/forgotPassword`, { state: { email: values.email } });
    } else {
      navigate(`/forgotPassword`, { state: { email: '' } });
    }
  };

  const loginForm = () => {
    return (
      <>
        <Typography
          className="fw-bold ff-Roboto createHeading"
          color={theme.palette.primary.main}
        >
          {' '}
          Welcome Back!{' '}
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={{
            email: data?.email || '',
            password: data?.password,
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => loginApi(values)}
        >
          {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
            <Form
              noValidate
              autoComplete="off"
            >
              <Stack
                flex={1}
                className="mt-9"
              >
                <FormTextField
                  label="Email"
                  name="email"
                  sx={{ mb: 0 }}
                  lowerCase={true}
                />
              </Stack>
              <Stack
                flex={1}
                className="mt-14"
              >
                <FormTextField
                  label="Password"
                  name="password"
                  type="password"
                  sx={{ mb: '14px' }}
                  forgotPassword={true}
                  onClickForgotPassword={() => onClickForgotPassword(values, errors)}
                  visibility={visibility}
                  setVisibility={(val) => setVisibility(val)}
                />
              </Stack>

              <Button
                sx={{
                  ...buttonStyle1,
                  width: '100%',
                  mt: '2.3px',
                  backgroundColor: theme.palette.primary.light,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                  color: theme.palette.background.main,
                }}
                disabled={!(dirty && isValid)}
                type="submit"
              >
                Login
              </Button>
            </Form>
          )}
        </Formik>
      </>
    );
  };

  return (
    <div
      className="loginContainer"
      style={{
        padding: isMobile ? '16px' : '0',
        minHeight: isMobile ? 'auto' : '100vh',
      }}
    >
      <Stack
        style={{ maxWidth: '1368px', margin: 'auto' }}
        direction="row"
        justifyContent="space-between"
      >
        <Stack
          className="leftStack"
          style={{ width: '100%' }}
        >
          <Stack className="formSubmittedStyle mt-28">
            <Stack direction="row" justifyContent={'center'}>
              {/* <Typography
                color={theme.palette.primary.light}
                className="fw-bold ff-Roboto"
                style={{ fontSize: '54px' }}
              >
                Carbon
              </Typography>
              <Typography
                color={theme.palette.secondary.main}
                className="fw-bold ff-Roboto"
                style={{ fontSize: '54px', marginLeft: '10px' }}
              >
                Wallet
              </Typography> */}
              <img src={Logo} className='w-[240px]' />
            </Stack>
            <div style={{ marginTop: '5vh' }}>{loginForm()}</div>
          </Stack>
        </Stack>
      </Stack>
    </div>
  );
}
